import { render } from "./ContentTools.vue?vue&type=template&id=dfac2fea&scoped=true"
import script from "./ContentTools.vue?vue&type=script&lang=js"
export * from "./ContentTools.vue?vue&type=script&lang=js"

import "./ContentTools.vue?vue&type=style&index=0&id=dfac2fea&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfac2fea"]])

export default __exports__